const BUCKET_STORAGE_KEY = 'welya.live-api-bucket';
const BUCKET_COUNT = 100;

type BucketStorage = Pick<Storage, 'getItem' | 'setItem'>;

export function parseCanaryPercent(raw: string | undefined): number {
  const percent = Number(raw);
  if (!Number.isFinite(percent)) return 0;
  return Math.min(Math.max(percent, 0), 100);
}

/** Tirage 0..99 propre au navigateur : un spectateur reste du même côté du canary d'une visite à l'autre. */
export function readCanaryBucket(
  storage: BucketStorage | null,
  random: () => number = Math.random,
): number {
  try {
    const stored = storage?.getItem(BUCKET_STORAGE_KEY);
    if (stored !== null && stored !== undefined && stored !== '') {
      const bucket = Number(stored);
      if (Number.isInteger(bucket) && bucket >= 0 && bucket < BUCKET_COUNT) return bucket;
    }
  } catch {
    // stockage indisponible : nouveau tirage, sans conséquence au-delà de la visite
  }
  const bucket = Math.floor(random() * BUCKET_COUNT);
  try {
    storage?.setItem(BUCKET_STORAGE_KEY, String(bucket));
  } catch {
    // idem
  }
  return bucket;
}

/** Le tirage n'est lu (et stocké) que si le canary est ouvert : sans config, rien ne change. */
export function shouldUseLiveApi(
  liveApiUrl: string | undefined,
  canaryPercent: number,
  readBucket: () => number,
): boolean {
  if (!liveApiUrl || canaryPercent <= 0) return false;
  return readBucket() < canaryPercent;
}

/**
 * Seuls les échecs d'infrastructure repassent par welya-api. Les 400/401/404 sont des réponses
 * métier identiques sur les deux services : on les rend telles quelles.
 */
export function isLiveApiFallbackError(error: unknown): boolean {
  if (error === null || typeof error !== 'object') return true;
  const { status, code } = error as { status?: number; code?: string };
  if (code === 'NETWORK' || status === undefined) return true;
  return status === 403 || status === 429 || status >= 500;
}
